<template>
  <div>
    <b-modal
      id="transaction-bulks"
      title="Transaction Bulks"
      ok-variant="success"
      ok-title="Save"
      ok-only
      :ok-disabled="submitting"
      :no-close-on-backdrop="submitting"
      :no-close-on-esc="submitting"
      :hide-header-close="submitting"
      @ok="submit"
      @hidden="bulk.file = null; bulkID = null"
    >
      <validation-observer ref="transactionBulksRef">
        <b-form>
          <b-form-group
            label="Transaction Operation"
            label-for="bulk-transaction-operation"
          >
            <b-form-select
              id="bulk-transaction-operation"
              v-model="bulk.transactionOperation"
              :options="transactionOperations"
              text-field="label"
              value-field="value"
            />
          </b-form-group>
          <validation-provider
            #default="{ errors }"
            name="File"
            rules="required"
          >
            <b-form-group
              label="File"
              label-for="bulk-transaction-file"
            >
              <b-form-file
                id="bulk-transaction-file"
                v-model="bulk.file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                :disabled="submitting"
                @change="setFile"
              />
              <span class="text-danger">
                {{ errors[0] }}
              </span>
            </b-form-group>
          </validation-provider>
        </b-form>
        <div class="d-flex justify-content-between align-items-center">
          <template v-if="submitting">
            <span>Please be patient...</span>
            <b-spinner />
          </template>
          <b-link
            v-if="!submitting && bulkID"
            :to="`bulks/list?id=${bulkID}`"
          >
            Bulk ID: {{ bulkID }}
          </b-link>
        </div>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormSelect, BFormGroup, BFormFile, BForm, BSpinner, BLink,
} from 'bootstrap-vue'
import { reactive, ref } from '@vue/composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '@/views/billing/billingStore'

export default {
  components: {
    BForm,
    BFormSelect,
    BFormGroup,
    BModal,
    ValidationObserver,
    ValidationProvider,
    BFormFile,
    BSpinner,
    BLink,
  },
  props: {
    userType: {
      type: String,
      required: true,
      description: 'either user or driver',
    },
  },
  data() {
    return {
      bulkID: null,
    }
  },
  methods: {
    async submit(evt) {
      evt.preventDefault()
      this.bulkID = null
      const valid = await this.transactionBulksRef.validate()
      if (!valid) return
      try {
        this.submitting = true
        const bulkId = await this.$store.dispatch('billing/addtransactionBulks', {
          transactionOperation: this.bulk.transactionOperation,
          file: this.bulk.file,
          user_type: this.userType,
        })
        this.bulkID = bulkId
      } catch (error) {
        this.$swal({
          title: 'Error!',
          text: error,
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
        this.$bvModal.hide('transaction-bulks')
      } finally {
        this.bulk.file = null
        this.transactionBulksRef.reset()
        this.submitting = false
      }
    },
  },
  setup(props) {
    useRegisterStoreModule('billing', store)
    const transactionBulksRef = ref(null)
    const transactionOperations = [
      {
        label: 'Add',
        value: 'add',
      },
      {
        label: 'Deduct',
        value: 'deduct',
      },
    ]
    if (props.userType === 'user') {
      transactionOperations.push({
        label: 'Waive Pending',
        value: 'waive_pending',
      })
    }
    const bulk = reactive({
      transactionOperation: 'add',
      file: null,
    })
    const submitting = ref(false)
    const setFile = e => {
      [bulk.file] = e.target.files
    }

    return {
      transactionBulksRef,
      transactionOperations,
      required,
      bulk,
      setFile,
      submitting,
    }
  },
}
</script>

<style>

</style>
